import { IPagedListResponse } from "domain/types/global/pagedListResponse"
import { LotePedidoResponse } from "./lotePedidoResponse"
import ValidationResult from "domain/types/global/validationResult";
import { PagarPedidoResponse } from "../pagarPedido/pagarPedidoResponse";

export const LOTEPEDIDO_GET = 'LOTEPEDIDO_GET'
export const LOTEPEDIDO_GET_BYID = 'LOTEPEDIDO_GET_BYID'
export const LOTEPEDIDO_CREATE = 'LOTEPEDIDO_CREATE'
export const LOTEPEDIDO_APROVAR = 'LOTEPEDIDO_APROVAR'
export const DELETARPEDIDO = 'DELETARPEDIDO'
export const PAGARPEDIDO = 'PAGARPEDIDO'
export const TENTARNOVAMENTE = 'TENTARNOVAMENTE'

export interface LotePedidoState {
    LotePedido: IPagedListResponse<LotePedidoResponse> | undefined,
    LotePedidoById: LotePedidoResponse | undefined,
    PagarPedido: PagarPedidoResponse | undefined
    mudancaStatus: ValidationResult;
}

export interface LotePedidoAction {
    type: typeof LOTEPEDIDO_GET,
    payload: IPagedListResponse<LotePedidoResponse>
}

export interface LotePedidoByIdAction {
    type: typeof LOTEPEDIDO_GET_BYID,
    payload: LotePedidoResponse
}

export interface LotePedidoAprovarAction {
    type: typeof LOTEPEDIDO_APROVAR,
    payload: ValidationResult
}

export interface CreateLotePedidoAction {
    type: typeof LOTEPEDIDO_CREATE,
    payload: ValidationResult
}

export interface DeletarPedidoAction {
    type: typeof DELETARPEDIDO,
    payload: ValidationResult
}

export interface PagarPedidoAction {
    type: typeof PAGARPEDIDO,
    payload: ValidationResult
}
export interface TentarNovamenteAction {
    type: typeof TENTARNOVAMENTE,
    payload: ValidationResult
}

export type LotePedidoActionTypes =
    LotePedidoAction |
    LotePedidoAprovarAction |
    CreateLotePedidoAction |
    LotePedidoByIdAction |
    DeletarPedidoAction |
    PagarPedidoAction |
    TentarNovamenteAction